// Imports
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { XhrService } from '../../../service/xhr.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { PostBody } from '../../../shared/postBody';

import { Project } from './project';

@Injectable()
export class ProjectService {
    // Resolve HTTP using the constructor
    constructor(private xhrService: XhrService) {
    }

    getInfo() {
        return this.xhrService.get('project/getInfo/');
    }

    getClone(id: number) {
        return this.xhrService.get('project/getInfo/' + id);
    }

    get(id: number) {
        return this.xhrService.get('project/read/' + id);
    }

    getAll() {
        return this.xhrService.get('project/read/');
    }

    create(project:Project) {
        let postBody:PostBody={method:'project.create'};
        postBody['project'] = project;
        return this.xhrService.post('project/create/',postBody);
    }


    generate(project:Project) {
        let postBody:PostBody={method:"project.generate"};
        postBody["project"] = project;
        return this.xhrService.post('project/generate/',postBody);
    }
    
    update(id:number,project:Project) {
        let postBody:PostBody={method:'project.update'};
        postBody['project'] = project;
        return this.xhrService.post('project/update/'+id,postBody);
    }

    delete(id:number) {
        return this.xhrService.get('project/delete/'+id);
    }


}



// WEBPACK FOOTER //
// ./src/app/module/project/shared/project.service.ts